import routerUtils from './routerUtils.js';

// 不需要微信授权、不强制留资
let otherRouter = [
    {
        name: 'aggregatePay',
        path: '/aggregatePay/:pathMatch(.*)*',
        title: 'PARTNER_NAME',
        component: () =>
            import(/* webpackChunkName: "aggregatePay" */ '../views/aggregatePay/index.vue').catch(
                routerUtils.catchImport,
            ),
    },
    {
        name: 'qnOnLinePay',
        path: '/qnOnLinePay/:pathMatch(.*)*',
        title: 'PARTNER_NAME',
        component: () =>
            import(/* webpackChunkName: "qnOnLinePay" */ '../views/qnOnLinePay/index.vue').catch(
                routerUtils.catchImport,
            ),
    },
];

function children(item) {
    let obj = {
        ...item,
        meta: {
            title: item.title,
            flag: item.meta,
        },
        path: item.name,
    };
    item.children && item.children.length > 0 && (obj.children = item.children.map(children));
    return obj;
}

// 不需要微信授权、不强制留资
otherRouter = otherRouter.map(item => ({
    ...item,
    meta: {
        title: item.title,
        flag: item.meta,
    },
    path: item.path ? item.path : `/${item.name}`,
    children: item.children && item.children.length > 0 ? item.children.map(children) : [],
}));

export const routes = [...otherRouter];
